import { Link } from 'react-router-dom';
import AIChatWidget from '@/components/AIChatWidget';

export const MarketingFooter = () => {
  return (
    <>
    <footer className="bg-[#070d1c] text-slate-400 border-t border-[#1f3a64] relative">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.png" alt="PROP VEIW" className="w-16 h-16 object-contain rounded-md bg-white/95 p-1 ring-1 ring-amber-300/30" />
            <span className="font-manrope font-bold text-white">PROP VEIW</span>
          </div>
          <p className="text-sm leading-relaxed">
            One inbox for guests, cleaners, contractors, and the books.
            Built for property managers who want their evenings back.
          </p>
        </div>

        <div>
          <h4 className="text-white font-medium mb-3 text-sm">Product</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-amber-200 transition-colors">Overview</Link></li>
            <li><Link to="/pricing" className="hover:text-amber-200 transition-colors">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-amber-200 transition-colors">Start free trial</Link></li>
            <li><Link to="/login" className="hover:text-amber-200 transition-colors">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="mailto:hello@propveiw.com" className="hover:text-amber-200 transition-colors">Contact</a></li>
            <li><a href="mailto:support@propveiw.com" className="hover:text-amber-200 transition-colors">Support</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-medium mb-3 text-sm">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="hover:text-amber-200 transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-amber-200 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/cookies" className="hover:text-amber-200 transition-colors" data-testid="footer-cookies-link">Cookie Notice</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1f3a64]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} PROP VEIW. All rights reserved.</span>
          <span>Made for property managers, by property managers.</span>
        </div>
      </div>
    </footer>
    <AIChatWidget theme="dark" />
    </>
  );
};

export default MarketingFooter;
